// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .main-content .section[data-v-887982cc]  .ag-theme-balham .ag-header-cell:after {\n  height: 100%;\n  top: unset;\n}\n#app .main-content .section[data-v-887982cc]  .ag-theme-balham .ag-cell {\n  border: none;\n  border-right: 1px solid var(--ag-header-column-separator-color, rgba(189, 195, 199, 0.5));\n}\n", ""]);
// Exports
module.exports = exports;
